import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
    es: {
        weekdays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        weekdaysShort: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    },
};

@Injectable()
export class DatepickerESI18n extends NgbDatepickerI18n {
    constructor() {
        super();
    }

    getWeekdayShortName(weekday: number): string {
        return I18N_VALUES.es.weekdaysShort[weekday - 1];
    }

    getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
        switch (width) {
            case TranslationWidth.Short:
                return this.getWeekdayShortName(weekday);
            case TranslationWidth.Wide:
                return I18N_VALUES.es.weekdays[weekday - 1];
            default:
                return this.getWeekdayShortName(weekday);
        }
    }

    getMonthShortName(month: number): string {
        return I18N_VALUES.es.monthsShort[month - 1];
    }

    getMonthFullName(month: number): string {
        return I18N_VALUES.es.months[month - 1];
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day} de ${this.getMonthFullName(date.month)} del ${date.year}`;
    }
}
